import React from 'react';
import IconWrapper from '../IconWrapper';
const NewWindowIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M11.27 4.58h.06a.5.5 0 010 1H2.77a.5.5 0 00-.5.5L2.18 21a.5.5 0 00.5.5l15 .08a.5.5 0 00.5-.5v-8.56a.5.5 0 011 0v9.06a1 1 0 01-1 1l-16-.08a1 1 0 01-1-1l.08-16a1 1 0 011-1z", fillRule: "evenodd" }),
    React.createElement("path", { d: "M21.19 1.58h-6.91v1.03h6.18L9.85 13.22l.72.73L21.19 3.33v6.18h1.03V1.58h-1.03z" })));
export default NewWindowIcon;
//# sourceMappingURL=NewWindowIcon.js.map